const getEnvValue = (key) => {
  if (typeof import.meta !== "undefined" && import.meta.env && import.meta.env[key]) {
    return import.meta.env[key];
  }
  if (typeof process !== "undefined" && process.env && process.env[key]) {
    return process.env[key];
  }
  return "";
};

export const CLOUD_FUNCTIONS_BASE_URL =
  getEnvValue("VITE_CLOUD_FUNCTIONS_BASE_URL") ||
  getEnvValue("REACT_APP_CLOUD_FUNCTIONS_BASE_URL") ||
  "https://europe-west1-beetinq-app.cloudfunctions.net";

export const CLOUD_FUNCTIONS_API_KEY =
  getEnvValue("VITE_CLOUD_FUNCTIONS_API_KEY") ||
  getEnvValue("REACT_APP_CLOUD_FUNCTIONS_API_KEY") ||
  "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";

export const GCF_GET_OR_CREATE_USER_BY_EMAIL_URL =
  getEnvValue("VITE_GCF_GET_OR_CREATE_USER_BY_EMAIL") ||
  getEnvValue("REACT_APP_GCF_GET_OR_CREATE_USER_BY_EMAIL") ||
  `${CLOUD_FUNCTIONS_BASE_URL}/getOrCreateUserByEmail`;
